import { fetchToken } from "../../../../common/FetchCookie";
import { PAYMENT_GATEWAY_TOP_UP } from "../../../../common/URLs";



export const PaymentGatewayTopUp = async (uuid) => {
    const url = `${PAYMENT_GATEWAY_TOP_UP}`; // Proxy path
    try {
        const token = await fetchToken()

        const response = await fetch(url, {
            method: "POST",
            headers: {
                // Accept: "application/json",
                "Content-type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(uuid),
        });
        const data = await response.json();
        // console.log("API Data", data);
        return data;
    } catch (error) {
        // console.log("error", error);
        throw error;
    }
};
